import styles from './pageTitle.module.css';

export default function PageTitle({ title, style = {}, className = '', titleStyle = {}, titleClassName = '', url = null, views = null }) {
  return (
    <div className={`${styles.container} ${className}`} style={views ? { marginBottom: '1.5rem', ...style } : { marginBottom: '64.6px', ...style }}>
      <h1 className={`${styles.title} ${titleClassName}`} style={views ? { borderBottom: '1px solid #ccc', ...titleStyle } : { ...titleStyle }}>
        {url ? <a href={url} target='_blank' rel='noreferrer noopener'>{title}</a> : title}
      </h1>
      {/* {views && <p className={styles.views}>تعداد بازدید: {views}</p>} */}
    </div>
  )
}
